module.exports = {"appConfigSource":"api","externalScriptsBasePath":"https://api-uk.kurtosys.app/applicationManager/apps/ksys-app-assets","cacheOptions":{"maxAge":604800}}


//////////////////
// WEBPACK FOOTER
// ./src/configuration/templateConfig.json
// module id = 573
// module chunks = 1